<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Lista" subTitle="Supervisores" />

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div
            class="card-header border-bottom d-md-flex justify-content-between"
          >
            <div
              class="col-md-3 col-12 d-flex justify-content-center justify-content-md-start align-items-center"
            >
              <h6 class="m-md-0 m-2">Supervisores ativos</h6>
            </div>
            <d-col sm="12" md="6">
              <input-search
                :model.sync="pagination.search"
                id="input_distributor_list_search"
              />
            </d-col>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <supervisor-table :supervisors="supervisors.list" />
            </div>
            <pagination
              :total-items="supervisors.total_items"
              :pagination.sync="pagination"
              :eventName="'update:pagination_supervisor_list'"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import InputSearch from '_shared/InputSearch.vue';
import PageHeader from '_shared/PageHeader.vue';
import paginationStorageMixin from '_common/mixins/paginationStorageMixin';
import SupervisorTable from '../components/SupervisorListTable.vue';

export default {
  name: 'supervisor-list',
  components: {
    PageHeader,
    SupervisorTable,
    Pagination,
    InputSearch,
  },
  mixins: [paginationStorageMixin],
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    supervisors() {
      const { supervisorList } = this.$store.state.supervisor;
      if (supervisorList && supervisorList.list.length) {
        return supervisorList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions(['checkAdmin', 'getSupervisorList']),
    getList() {
      this.getSupervisorList(this.pagination);
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination_supervisor_list', pagination => {
      const paramsPage = parseInt(this.$route.params.page, 10);
      this.saveCurrentPage(this.pagination);
      if (paramsPage !== pagination.page) {
        this.$router.push({ params: { page: pagination.page } });
      }
      this.getList();
    });
  },
  destroyed() {
    Events.$off('update:pagination_supervisor_list');
  },
};
</script>
